import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext, useSearchParams } from 'react-router-dom';
import { Card } from "../../common_components/Layout";
import { TitleAndText } from "../components/TitleAndText";
import { PrimaryButton } from "../../common_components/Buttons";
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";


import { useAlert } from 'react-alert'


// Api Calls
import PaymentAPI from "../../../api/api_calls/PaymentAPI";


function CryptoConfirmation(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()



    // useEffect(() => {
    //     // Retrieve the session. 
    //     async function retrieveCheckoutSession() {
    //         const result = await PaymentAPI.retrieveCheckoutSession({ missionId, session_id, navigate });

    //         if (result.success) {

    //         } else {
    //             alert.show(result.error, { type: 'error' })
    //         }
    //     }

    //     retrieveCheckoutSession();
    // }, []);



    // function onMissionNameChange(event) {
    //     setMissionName(event.target.value);
    // }
    // function onMissionDescriptionChange(event) {
    //     setMissionDescription(event.target.value);
    // }

    // function onClickBack() {
    //     navigate(backPage, { state: { missionId: missionId } })
    // }





    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title="Project Ready!" subtitle="Your information has been saved. We'll reach out shortly and your Project should be launched within 24 hours. We'll invoice you upon completion of the Project." hidePrice={true} />
            <div className="payment-confirmation-text">
                Questions? <a href="https://desparkwiki.notion.site/researcher-guide" target="_blank" rel="noopener noreferrer" className="white-link">View our researcher guide</a> for more information.
            </div>
            <PrimaryButton onClick={() => navigate("/dashboard")} text="Back to Dashboard" />
        </div>


    )
}

export default CryptoConfirmation;